export default __webpack_public_path__ + "static/media/furniture.a9dc0fa1.jpg";